import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { SuggestedPetition } from '../../../../shared/api';

import type {
	SuggestedPetitionsFromPetitionV2Query,
	SuggestedPetitionsFromPetitionV2QueryVariables,
	SuggestedPetitionsV2Query,
	SuggestedPetitionsV2QueryVariables,
} from './api.graphql';
import { SuggestedPetitionsFromPetitionV2, SuggestedPetitionsV2 } from './api.graphql';

const MAX_PETITIONS = 24;

type Options = Readonly<{
	petitionSlugOrId?: string;
	locale: string;
	countryCode: string;
	channel: Channel;
}>;

// TODO add missing channels?
export type Channel = 'search_index' | 'petition_footer' | 'update_footer' | 'dm_responses';

export async function getSuggestedPetitions(
	{ petitionSlugOrId, countryCode, locale, channel }: Options,
	{ gql: { fetch } }: UtilityContext,
): Promise<{ petitions: readonly SuggestedPetition[]; parentPetitionId?: string }> {
	if (petitionSlugOrId) {
		const { data } = await fetch<SuggestedPetitionsFromPetitionV2Query, SuggestedPetitionsFromPetitionV2QueryVariables>(
			{
				query: SuggestedPetitionsFromPetitionV2,
				variables: {
					petitionSlugOrId,
					count: MAX_PETITIONS,
					channel,
					countryCode,
					locale,
				},
				// to separate query from other batched queries
				batched: false,
				rejectOnError: true,
			},
		);
		if (!data.petition) {
			throw new Error('petition not found');
		}
		return {
			petitions: data.petition.suggestedPetitionsConnection.edges,
			parentPetitionId: data.petition.id,
		};
	}

	const { data } = await fetch<SuggestedPetitionsV2Query, SuggestedPetitionsV2QueryVariables>({
		query: SuggestedPetitionsV2,
		variables: {
			count: MAX_PETITIONS,
			channel,
			countryCode,
			locale,
		},
		// to separate query from other batched queries
		batched: false,
		rejectOnError: true,
	});
	return {
		petitions: data.result.petitions,
	};
}
